import React, { useEffect, useState } from 'react'

// components
import ManageInfo from '../../components/storeInfo/ManageInfo'

const ManageStoreInfo = () => {
  return (
    <>
      <ManageInfo />
    </>
  )
}

export default ManageStoreInfo
